// @ts-nocheck
import _ from 'lodash';
import React, { forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import omitEmpty from 'omit-empty';
import {
  makeStyles,
  Box,
  Grid,
  Icon,
  Button,
  Typography,
} from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { useIfMounted } from '../../../../common/hooks';
import { DateUtils, StringUtils } from '../../../../common/utils';

const useStyles = makeStyles(theme => ({
  container: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '720px',
  },
  formContent: {
    flex: '1',
    display: 'flex',
    flexWrap: 'wrap',
    padding: theme.spacing(1, 3),
    overflow: 'auto',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(1),
    '&:last-child': {
      marginRight: '0',
    },
  },
  label: {
    padding: theme.spacing(1, 0),
  },
}));

const PromotionConfirmation = React.forwardRef((props, ref) => {
  const [t] = useTranslation();
  const classes = useStyles();
  const ifMounted = useIfMounted();

  const {
    promotion,
    onSave,
    onCancel,
    cancelButtonText,
    cancelButtonIcon,
    saveButtonText,
    saveButtonIcon,
    getTypeDisplayValue,
  } = props;

  const onConfirm = () => {
    onSave(promotion);
  };

  return (
    <Box id="PromotionPeriodForm-container" className={classes.container}>
      <Box className={classes.formContent}>
        <Grid
          id="confirmation"
          container
          item
          xs={12}
        >
          <Grid item xs={12}>
            <Typography
              id="promotionCodeLabel"
              className={classes.label}
            >
              <b>{`${t('promotion.promotionCode')}: `}</b>
            {!_.isNil(promotion.code) && (
                promotion.code
            )}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              id="promotionTypeLabel"
              className={classes.label}
            >
              <b>{`${t('promotion.promotionType')}: `}</b>
              {!_.isNil(promotion.type) && (
                getTypeDisplayValue(promotion.type)
              )}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              id="promotionDiscountValueLabel"
              className={classes.label}
            >
              <b>{`${t('promotion.promotionDiscountValue')}: `}</b>
              {!_.isNil(promotion.discountValue) && (
                promotion.discountType === 'PERCENT' ? `${promotion.discountValue} %` : StringUtils.getFormattedSum(promotion.discountValue)
              )}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              id="promotionDiscountDurationLabel"
              className={classes.label}
            >
              <b>{`${t('promotion.promotionSummaryDiscountDuration')}: `}</b>
              {!_.isNil(promotion.discountDuration) && (
                StringUtils.getFormattedDays(promotion.discountDuration)
              )}
            </Typography>
          </Grid>
          {promotion.conditions && (
            <Grid item xs={12}>
              <Typography
                id="promotionConditionsLabel"
                className={classes.label}
              >
                <b>{`${t('promotion.promotionSummaryConditions')}: `}</b>
                {!_.isNil(promotion.conditions) && (
                  promotion.conditions
                )}
              </Typography>
            </Grid>
          )}
          <Grid item xs={12}>
            <Typography
              id="promotionCurrentProductLabel"
              className={classes.label}
            >
              <b>{`${t('promotion.promotionSummaryRestrictedProducts')}: `}</b>
              {!_.isNil(promotion.restrictedProducts) && (
                promotion.restrictedProducts
                  .map(product => StringUtils.getTranslation(t, 'product.types', product, ""))
                  .join(', ')
              )}
            </Typography>
          </Grid>
          {promotion.type === 'CHANGE' && (
            <Grid item xs={12}>
              <Typography
                id="promotionUpgradeProductLabel"
                className={classes.label}
              >
                <b>{`${t('promotion.promotionSummaryChangeProducts')}: `}</b>
                {!_.isNil(promotion.changeProducts) && (
                StringUtils.getTranslation(t, 'product.types', promotion.changeProducts[0], "")
                )}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>
      <Box id='Promotion-actions' className={classes.actions}>
        <Button
          id="Promotion-cancel"
          className={classes.button}
          startIcon={<Icon>{_.defaultTo(cancelButtonIcon, 'cancel')}</Icon>}
          onClick={onCancel}
        >
          <Typography variant="button" noWrap>
            {_.defaultTo(cancelButtonText, t('common.cancel'))}
          </Typography>
        </Button>
        <Button
          id="Promotion-save"
          onClick={onConfirm}
          color="primary"
          className={classes.button}
          startIcon={<Icon>{_.defaultTo(saveButtonIcon, 'save')}</Icon>}
        >
          <Typography variant="button" noWrap>
            {_.defaultTo(saveButtonText, t('promotion.promotionCreate'))}
          </Typography>
        </Button>
      </Box>
    </Box>
  );
});

PromotionConfirmation.propTypes = {
  promotion: PropTypes.object.isRequired,
  cancelButtonText: PropTypes.string,
  cancelButtonIcon: PropTypes.string,
  saveButtonText: PropTypes.string,
  saveButtonIcon: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  getTypeDisplayValue: PropTypes.func.isRequired,
};

export default PromotionConfirmation;
